import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=6192b96c&"
import script from "./datatable.vue?vue&type=script&lang=ts&"
export * from "./datatable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports